// import React from "react";
// import { formatDate } from "../../../../components/common/Converter";
// function getLeaveTypeAbbreviation(leaveType) {
//   // For any other value, return the first letter of each word in the leaveType
//   return (
//     leaveType
//       ?.split(" ")
//       ?.map((word) => word.charAt(0).toUpperCase()) // Take the first letter of each word
//       ?.join("") || ""
//   );
// }

// export default function GenerateLeaveCard({
//   object,
//   leaveRequest,
// }) {
//   const empName = `${object?.Firstname} ${object?.Middlename || ""} ${
//     object?.surname
//   }`;

//   const division = object?.unit ? object?.unit.toUpperCase() : "";
//   const empPosition = object?.position?.position_title || "";
//   const dateHired = formatDate(object?.hired) || "";

//   const cellStyle = {
//     border: "1px solid black",
//     // padding: "5px",
//     textAlign: "center",
//   };

//   const cellData = {
//     border: "1px solid black",
//     padding: "5px",
//     textAlign: "center",
//   };

//   const headerStyle = {
//     ...cellStyle,
//     fontWeight: "bold",
//   };

//   const dateFormatter = (date) => {
//     if (isNaN(date)) {
//       return "";
//     }
//     const newDate = new Date(date);
//     // newDate.setDate(newDate.getDate() - 1);
//     const mm = newDate.getMonth() + 1; // getMonth() is 0-based
//     const dd = newDate.getDate();
//     const yy = newDate.getFullYear().toString().slice(-2);
//     return `${mm}/${dd}/${yy}`;
//   };

//   // Step 1: Separate vacation and sick leaves
//   const vacationLeaves = leaveRequest?.filter(
//     (l) =>
//       l.leaveType === "Vacation Leave" ||
//       l.leaveType === "Forced/Mandatory Leave",
//   );
//   const sickLeaves = leaveRequest?.filter((l) => l.leaveType === "Sick Leave");

//   // Step 2: Create row pairs (1 VL + 1 SL)
//   const maxLen = Math.max(vacationLeaves?.length, sickLeaves?.length);
//   const rowPairs = Array.from({ length: maxLen }, (_, i) => ({
//     vl: vacationLeaves[i] || {},
//     sl: sickLeaves[i] || {},
//   }));

//   const getDateDifferenceInDays = (date1, date2) => {
//     // if (isNaN(date1) || isNaN(date2)) {
//     //   return "";
//     // }
//     const diffMs = Math.abs(new Date(date2) - new Date(date1)); // difference in ms
//     const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24)); // convert to days
//     return diffDays + 1;
//   };

//   return (
//     <div
//       style={{
//         width: "8.27in", // Legal paper width
//         height: "11.69in", // Legal paper height
//         padding: "0 1rem",
//       }}
//     >
//       <header style={{ display: "grid", marginBottom: "1rem" }}>
//         <div style={{ textAlign: "center", fontSize: "2rem", display: "grid" }}>
//           <label>BUREAU OF IMMIGRATION</label>
//           <div style={{ display: "inline-block", margin: "1rem 0" }}>
//             <label
//               style={{
//                 borderTop: "3px solid black",
//                 borderBottom: "3px solid black",
//                 padding: "0 10px",
//               }}
//             >
//               LEAVE CARD
//             </label>
//           </div>
//         </div>
//         <labl>Name: {empName}</labl>
//         <labl>Position: {empPosition}</labl>
//         <labl>Date Hired: {dateHired}</labl>
//       </header>

//       <section style={{ border: "1px solid" }}>
//         <div
//           style={{
//             borderTop: "1px solid",
//             borderBottom: "1px solid",
//             display: "flex",
//             justifyContent: "space-evenly",
//           }}
//         >
//           <label>{division}</label>
//           <label>1st DAY OF SERVICE</label>
//         </div>
//         <table
//           style={{
//             borderCollapse: "collapse",
//             width: "100%",
//             fontFamily: "Arial, sans-serif",
//             fontSize: "10px",
//           }}
//         >
//           <thead>
//             <tr>
//               <th rowSpan="2" style={headerStyle}>
//                 PERIOD
//               </th>
//               {/* <th rowSpan="2" style={headerStyle}>
//                 PARTICULARS
//               </th> */}
//               <th colSpan="4" style={headerStyle}>
//                 VACATION LEAVE
//               </th>
//               <th colSpan="4" style={headerStyle}>
//                 SICK LEAVE
//               </th>
//               <th rowSpan="2" style={headerStyle}>
//                 DATE AND ACTION TAKEN ON APPL. FOR LEAVE
//               </th>
//             </tr>
//             <tr>
//               <th style={cellStyle}>EARNED</th>
//               <th style={cellStyle}>ABS.UND. W / P</th>
//               <th style={cellStyle}>ABS.UND. WOP</th>
//               <th style={cellStyle}>BAL.</th>
//               <th style={cellStyle}>EARNED</th>
//               <th style={cellStyle}>ABS.UND. W / P</th>
//               <th style={cellStyle}>ABS.UND. WOP</th>
//               <th style={cellStyle}>BAL.</th>
//             </tr>
//           </thead>
//           <tbody>
//             {Array.from(
//               { length: Math.max(30, rowPairs?.length) },
//               (_, index) => {
//                 const { vl = {}, sl = {} } = rowPairs[index] || {};

//                 const VLperiod = vl?.startDate
//                   ? `${getLeaveTypeAbbreviation(
//                       vl.leaveType,
//                     )} - ${dateFormatter(
//                       new Date(vl.startDate),
//                     )} - ${dateFormatter(new Date(vl.endDate))}`
//                   : "";

//                 const SLperiod = sl?.startDate
//                   ? `${getLeaveTypeAbbreviation(
//                       sl.leaveType,
//                     )} - ${dateFormatter(
//                       new Date(sl.startDate),
//                     )} - ${dateFormatter(new Date(sl.endDate))}`
//                   : "";

//                 const period = [VLperiod, SLperiod].filter(Boolean).join(" - ");

//                 /* vacation leave  */
//                 const VLrequestRange =
//                   getDateDifferenceInDays(vl?.startDate, vl?.endDate) || 0;
//                 console.log("Range: ", VLrequestRange);
//                 const VLDeduction =
//                   VLrequestRange - parseFloat(vl?.withPay) || "";

//                 /* sick leave  */

//                 const SLrequestRange =
//                   getDateDifferenceInDays(sl?.startDate, sl?.endDate) || 0;
//                 const SLDeduction =
//                   SLrequestRange - parseFloat(sl?.withPay) || "";

//                 /* console.log("VLD: ", SLDeduction); */
//                 return (
//                   <tr key={index}>
//                     {[
//                       {
//                         value: period,
//                       },
//                       {
//                         value: vl?.earned || "",
//                       },
//                       {
//                         value: vl?.withPay ? `-${vl?.withPay}` : "",
//                       },
//                       {
//                         value: VLDeduction ? `-${VLDeduction}` : "",
//                       },
//                       {
//                         value: vl?.balance || "",
//                       },
//                       {
//                         value: sl?.earned || "",
//                       },
//                       {
//                         value: sl?.withPay ? `-${sl?.withPay}` : "",
//                       },
//                       {
//                         value: SLDeduction ? `-${SLDeduction}` : "",
//                       },
//                       {
//                         value: sl?.balance || "",
//                       },
//                       {
//                         /* {
//                         value: {},
//                       }, */
//                       },
//                     ].map(({ value }) => (
//                       <td
//                         style={{
//                           ...cellData,
//                           height: "1.5rem",
//                         }}
//                       >
//                         {value}
//                       </td>
//                     ))}
//                   </tr>
//                 );
//               },
//             )}
//           </tbody>
//         </table>
//       </section>
//     </div>
//   );
// }
import React from "react";
import { formatDate } from "../../../../components/common/Converter";
function getLeaveTypeAbbreviation(leaveType) {
  // For any other value, return the first letter of each word in the leaveType
  return (
    leaveType
      ?.split(" ")
      ?.map((word) => word.charAt(0).toUpperCase()) // Take the first letter of each word
      ?.join("") || ""
  );
}

export default function GenerateLeaveCard({ object, leaveRequest }) {
  const empName = `${object?.Firstname} ${object?.Middlename || ""} ${
    object?.surname
  }`;

  const division = object?.unit ? object?.unit.toUpperCase() : "";
  const empPosition = object?.position?.position_title || "";
  const dateHired = formatDate(object?.hired) || "";

  const cellStyle = {
    border: "1px solid black",
    // padding: "5px",
    textAlign: "center",
  };

  const cellData = {
    border: "1px solid black",
    padding: "5px",
    textAlign: "center",
  };

  const headerStyle = {
    ...cellStyle,
    fontWeight: "bold",
  };

  const dateFormatter = (date) => {
    if (isNaN(date)) {
      return "";
    }
    const newDate = new Date(date);
    // newDate.setDate(newDate.getDate() - 1);
    const mm = newDate.getMonth() + 1; // getMonth() is 0-based
    const dd = newDate.getDate();
    const yy = newDate.getFullYear().toString().slice(-2);
    return `${mm}/${dd}/${yy}`;
  };

  // Separate vacation and sick leaves
  const vacationLeaves = leaveRequest?.filter(
    (l) =>
      l.leaveType === "Vacation Leave" ||
      l.leaveType === "Forced/Mandatory Leave",
  );
  const sickLeaves = leaveRequest?.filter((l) => l.leaveType === "Sick Leave");

  // Combine all leaves into a single array
  const allLeaves = [
    ...(vacationLeaves?.map((l) => ({ ...l, leaveCategory: "vacation" })) ||
      []),
    ...(sickLeaves?.map((l) => ({ ...l, leaveCategory: "sick" })) || []),
  ];

  const getDateDifferenceInDays = (date1, date2) => {
    const diffMs = Math.abs(new Date(date2) - new Date(date1)); // difference in ms
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24)); // convert to days
    return diffDays + 1;
  };

  return (
    <div
      style={{
        width: "8.27in", // Legal paper width
        height: "11.69in", // Legal paper height
        padding: "0 1rem",
      }}
    >
      <header style={{ display: "grid", marginBottom: "1rem" }}>
        <div style={{ textAlign: "center", fontSize: "2rem", display: "grid" }}>
          <label>BUREAU OF IMMIGRATION</label>
          <div style={{ display: "inline-block", margin: "1rem 0" }}>
            <label
              style={{
                borderTop: "3px solid black",
                borderBottom: "3px solid black",
                padding: "0 10px",
              }}
            >
              LEAVE CARD
            </label>
          </div>
        </div>
        <labl>Name: {empName}</labl>
        <labl>Position: {empPosition}</labl>
        <labl>Date Hired: {dateHired}</labl>
      </header>

      <section style={{ border: "1px solid" }}>
        <div
          style={{
            borderTop: "1px solid",
            borderBottom: "1px solid",
            display: "flex",
            justifyContent: "space-evenly",
          }}
        >
          <label>{division}</label>
          <label>1st DAY OF SERVICE</label>
        </div>
        <table
          style={{
            borderCollapse: "collapse",
            width: "100%",
            fontFamily: "Arial, sans-serif",
            fontSize: "10px",
          }}
        >
          <thead>
            <tr>
              <th rowSpan="2" style={headerStyle}>
                PERIOD
              </th>
              {/* <th rowSpan="2" style={headerStyle}>
                PARTICULARS
              </th> */}
              <th colSpan="4" style={headerStyle}>
                VACATION LEAVE
              </th>
              <th colSpan="4" style={headerStyle}>
                SICK LEAVE
              </th>
              <th rowSpan="2" style={headerStyle}>
                DATE AND ACTION TAKEN ON APPL. FOR LEAVE
              </th>
            </tr>
            <tr>
              <th style={cellStyle}>EARNED</th>
              <th style={cellStyle}>ABS.UND. W / P</th>
              <th style={cellStyle}>ABS.UND. WOP</th>
              <th style={cellStyle}>BAL.</th>
              <th style={cellStyle}>EARNED</th>
              <th style={cellStyle}>ABS.UND. W / P</th>
              <th style={cellStyle}>ABS.UND. WOP</th>
              <th style={cellStyle}>BAL.</th>
            </tr>
          </thead>
          <tbody>
            {Array.from(
              { length: Math.max(30, allLeaves?.length) },
              (_, index) => {
                const leave = allLeaves[index] || {};
                const isVacationLeave = leave.leaveCategory === "vacation";

                const period = leave?.startDate
                  ? `${getLeaveTypeAbbreviation(
                      leave.leaveType,
                    )} - ${dateFormatter(
                      new Date(leave.startDate),
                    )} - ${dateFormatter(new Date(leave.endDate))}`
                  : "";

                const requestRange =
                  getDateDifferenceInDays(leave?.startDate, leave?.endDate) ||
                  0;
                const deduction =
                  requestRange - parseFloat(leave?.withPay) || "";

                return (
                  <tr key={index}>
                    <td style={cellData}>{period}</td>

                    {/* Vacation Leave Columns */}
                    {isVacationLeave ? (
                      <>
                        <td style={cellData}>{leave?.earned || ""}</td>
                        <td style={cellData}>
                          {leave?.withPay ? `-${leave?.withPay}` : ""}
                        </td>
                        <td style={cellData}>
                          {deduction ? `-${deduction}` : ""}
                        </td>
                        <td style={cellData}>{leave?.balance || ""}</td>
                      </>
                    ) : (
                      <>
                        <td style={cellData}></td>
                        <td style={cellData}></td>
                        <td style={cellData}></td>
                        <td style={cellData}></td>
                      </>
                    )}

                    {/* Sick Leave Columns */}
                    {!isVacationLeave ? (
                      <>
                        <td style={cellData}>{leave?.earned || ""}</td>
                        <td style={cellData}>
                          {leave?.withPay ? `-${leave?.withPay}` : ""}
                        </td>
                        <td style={cellData}>
                          {deduction ? `-${deduction}` : ""}
                        </td>
                        <td style={cellData}>{leave?.balance || ""}</td>
                      </>
                    ) : (
                      <>
                        <td style={cellData}>&nbsp;</td>
                        <td style={cellData}>&nbsp;</td>
                        <td style={cellData}>&nbsp;</td>
                        <td style={cellData}>&nbsp;</td>
                      </>
                    )}

                    {/* Action Taken Column */}
                    <td style={cellData}>&nbsp;</td>
                  </tr>
                );
              },
            )}
          </tbody>
        </table>
      </section>
    </div>
  );
}
